import { render, staticRenderFns } from "./otherJobItem.vue?vue&type=template&id=77284707&scoped=true"
import script from "./otherJobItem.vue?vue&type=script&lang=js"
export * from "./otherJobItem.vue?vue&type=script&lang=js"
import style0 from "./otherJobItem.vue?vue&type=style&index=0&id=77284707&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77284707",
  null
  
)

export default component.exports